import { Link } from 'react-router-dom';
import { applicationScenarios } from '@/mocks/home';

function ApplicationScenarios() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-background-50 overflow-hidden">
      {/* Subtle decorative blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 -right-40 w-[500px] h-[500px] rounded-full bg-accent-500/[0.02] blur-[120px]" />
        <div className="absolute -bottom-20 -left-40 w-[450px] h-[450px] rounded-full bg-primary-500/[0.015] blur-[130px]" />
      </div>

      <div className="max-w-7xl mx-auto relative">
        {/* Section header */}
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 mb-5 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">
            应用场景
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-4 tracking-tight">
            覆盖全场景翻译需求
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
            从政企保密会议到个人跨境出行，新译为每个场景提供专属 AI 翻译方案
          </p>
        </div>

        {/* 2x2 grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {applicationScenarios.map((scenario) => (
            <div
              key={scenario.id}
              className="group bg-white rounded-2xl border border-background-200 overflow-hidden hover:border-primary-200/70 transition-all duration-400 hover:-translate-y-1 hover:shadow-[0_8px_30px_-8px_rgba(0,0,0,0.05)] flex flex-col md:flex-row"
            >
              {/* Image */}
              <div className="md:w-2/5 h-52 md:h-auto flex-shrink-0 overflow-hidden relative">
                <img
                  src={scenario.imageSrc || `https://readdy.ai/api/search-image?query=$%7Bscenario.imageQuery%7D&width=500&height=400&seq=scene-${scenario.id}&orientation=landscape`}
                  alt={scenario.title}
                  className="w-full h-full object-cover object-top transition-all duration-600 group-hover:scale-105"
                />
                {/* Image bottom fade to blend with content */}
                <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-white/20 to-transparent md:hidden" />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6 flex flex-col justify-center flex-1">
                {/* Title row */}
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300 flex-shrink-0">
                    <i className={`${scenario.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-foreground-900">{scenario.title}</h3>
                </div>

                {/* Description */}
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">{scenario.desc}</p>

                {/* Linked products */}
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs text-foreground-400">适配产品：</span>
                  {scenario.products.map((product, idx) => (
                    <Link
                      key={idx}
                      to={scenario.productLinks[idx]}
                      className="text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {product}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ApplicationScenarios;